import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg';
import { RenewalsMatrixContractDetailsComponent } from './pages/renewals-matrix-contract-details/renewals-matrix-contract-details.component';
import { RenewalsMatrixCustomerDetailsComponent } from './pages/renewals-matrix-customer-details/renewals-matrix-customer-details.component';
import { RenewalsMatrixGetQuoteComponent } from './pages/renewals-matrix-get-quote/renewals-matrix-get-quote.component';
import { RenewalsMatrixUtilityAccountsComponent } from './pages/renewals-matrix-utility-accounts/renewals-matrix-utility-accounts.component';
import { RenewalsMatrixYoureDoneComponent } from './pages/renewals-matrix-youre-done/renewals-matrix-youre-done.component';

const routes: Routes = [
  { path: ':quoteRequestId/customer-details', component: RenewalsMatrixCustomerDetailsComponent },
  { path: ':quoteRequestId/utility-accounts', component: RenewalsMatrixUtilityAccountsComponent },
  { path: ':quoteRequestId/get-quote', component: RenewalsMatrixGetQuoteComponent },
  { path: ':quoteRequestId/contract-details', component: RenewalsMatrixContractDetailsComponent },
  { path: ':quoteRequestId/youre-done', component: RenewalsMatrixYoureDoneComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    InlineSVGModule
  ],
  exports: [RouterModule]
})
export class RenewalsMatrixRoutingModule { }
